module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.page) ? _c('div', [_vm._v("\n  คุณได้เลือก " + _vm._s(_vm.page.title) + " "), (_vm.clearButton) ? _c('a', {
    staticClass: "btn-clear",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.clear($event)
      }
    }
  }, [_vm._v("เลือกใหม่")]) : _vm._e()]) : _vm._e()
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-421747c0", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-421747c0","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/PagePreview.vue
// module id = 737
// module chunks = 1